import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { TIME_FORMAT } from '../Constant';

/**
 * Reusable fetcher to be used with useSWR
 */
export const fetcher = (url: string) => fetch(url).then((res) => res.json());

export const minutesToTime = (value: number): string => {
    dayjs.extend(utc);
    return dayjs.utc(value * 60 * 1000).format(TIME_FORMAT);
};

export const subtractArray = <T>(a: T[], b: T[]) => a.filter((i) => !b.includes(i));

export const dateAsTimeToMinute = (value: dayjs.Dayjs): number => value.hour() * 60 + value.minute();

export const minuteToMilliseconds = (value: number) => value * 60 * 1000;
